// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-select-panel mat-option.mat-option {
  height: unset;
}

.mat-option-text.mat-option-text {
  white-space: normal;
}
.example-radio-group {
  display: flex;
  flex-direction: column;
  margin: 15px 0;
}

.example-radio-button {
  margin: 5px;
}

.checkbox-slides {
  margin-top: 15px;
}

#SinglePageView .example-radio-group {
  display: flex;
  flex-direction: row;
  margin: 0;
}

#SinglePageView .form-group {
  margin: 0;
}

.submit-btn{
  width: 130px; 
}
@media(max-width:375px){
  .submit-btn{
    width: 80px; 
  }
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN1cnZleS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBYTtBQUNmOztBQUVBO0VBQ0UsbUJBQW1CO0FBQ3JCO0FBQ0E7RUFDRSxhQUFhO0VBQ2Isc0JBQXNCO0VBQ3RCLGNBQWM7QUFDaEI7O0FBRUE7RUFDRSxXQUFXO0FBQ2I7O0FBRUE7RUFDRSxnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxhQUFhO0VBQ2IsbUJBQW1CO0VBQ25CLFNBQVM7QUFDWDs7QUFFQTtFQUNFLFNBQVM7QUFDWDs7QUFFQTtFQUNFLFlBQVk7QUFDZDtBQUNBO0VBQ0U7SUFDRSxXQUFXO0VBQ2I7QUFDRiIsImZpbGUiOiJzdXJ2ZXkuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tYXQtc2VsZWN0LXBhbmVsIG1hdC1vcHRpb24ubWF0LW9wdGlvbiB7XHJcbiAgaGVpZ2h0OiB1bnNldDtcclxufVxyXG5cclxuLm1hdC1vcHRpb24tdGV4dC5tYXQtb3B0aW9uLXRleHQge1xyXG4gIHdoaXRlLXNwYWNlOiBub3JtYWw7XHJcbn1cclxuLmV4YW1wbGUtcmFkaW8tZ3JvdXAge1xyXG4gIGRpc3BsYXk6IGZsZXg7XHJcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcclxuICBtYXJnaW46IDE1cHggMDtcclxufVxyXG5cclxuLmV4YW1wbGUtcmFkaW8tYnV0dG9uIHtcclxuICBtYXJnaW46IDVweDtcclxufVxyXG5cclxuLmNoZWNrYm94LXNsaWRlcyB7XHJcbiAgbWFyZ2luLXRvcDogMTVweDtcclxufVxyXG5cclxuI1NpbmdsZVBhZ2VWaWV3IC5leGFtcGxlLXJhZGlvLWdyb3VwIHtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XHJcbiAgbWFyZ2luOiAwO1xyXG59XHJcblxyXG4jU2luZ2xlUGFnZVZpZXcgLmZvcm0tZ3JvdXAge1xyXG4gIG1hcmdpbjogMDtcclxufVxyXG5cclxuLnN1Ym1pdC1idG57XHJcbiAgd2lkdGg6IDEzMHB4OyBcclxufVxyXG5AbWVkaWEobWF4LXdpZHRoOjM3NXB4KXtcclxuICAuc3VibWl0LWJ0bntcclxuICAgIHdpZHRoOiA4MHB4OyBcclxuICB9XHJcbn1cclxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/survey/survey.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;AACA;EACE;IACE,WAAW;EACb;AACF;;AAEA,o4CAAo4C","sourcesContent":[".mat-select-panel mat-option.mat-option {\r\n  height: unset;\r\n}\r\n\r\n.mat-option-text.mat-option-text {\r\n  white-space: normal;\r\n}\r\n.example-radio-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 15px 0;\r\n}\r\n\r\n.example-radio-button {\r\n  margin: 5px;\r\n}\r\n\r\n.checkbox-slides {\r\n  margin-top: 15px;\r\n}\r\n\r\n#SinglePageView .example-radio-group {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin: 0;\r\n}\r\n\r\n#SinglePageView .form-group {\r\n  margin: 0;\r\n}\r\n\r\n.submit-btn{\r\n  width: 130px; \r\n}\r\n@media(max-width:375px){\r\n  .submit-btn{\r\n    width: 80px; \r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
